{
  "nav": {
    "dashboard": "Dashboard",
    "exams": "Exams",
    "tests": "My Tests",
    "results": "Results",
    "leaderboard": "Leaderboard",
    "credits": "Credits",
    "admin": "Admin",
    "logout": "Sign out"
  },
  "auth": {
    "sign_in": "Sign in",
    "sign_up": "Sign up",
    "email": "Email",
    "password": "Password",
    "forgot_password": "Forgot password?"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "loading": "Loading…",
    "confirm": "Are you sure?",
    "search": "Search",
    "filter": "Filter",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "yes": "Yes",
    "no": "No"
  },
  "theme": {
    "dark": "Dark",
    "light": "Light",
    "system": "System"
  },
  "test": {
    "start": "Start Test",
    "reattempt": "Reattempt",
    "submit": "Submit Test",
    "time_remaining": "Time remaining",
    "question": "Question",
    "marked_for_review": "Marked for review",
    "answered": "Answered",
    "not_answered": "Not answered",
    "not_visited": "Not visited"
  },
  "credits": {
    "balance": "Credit Balance",
    "purchase": "Purchase Access",
    "cost": "{{count}} credits",
    "insufficient": "Insufficient credits"
  }
}
